import { ThemeKey } from "@smartsheet/design-tokens";
import React, { forwardRef } from "react";
import { HTMLAttributes } from "react";
import { useTheme } from "../../../theme/utils/useTheme";
import { TooltipBodyStyled } from "../styled/TooltipBodyStyled";

// Nothing here on purpose, just keeping the namespace open.
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface TooltipBodyProps extends HTMLAttributes<HTMLDivElement> {}

export const TooltipBody = forwardRef<HTMLDivElement, TooltipBodyProps>(({ children, ...rest }, ref) => {
    const { key } = useTheme();
    const themeMode = key as ThemeKey;
    return (
        <TooltipBodyStyled {...rest} themeMode={themeMode} ref={ref}>
            {children}
        </TooltipBodyStyled>
    );
});

TooltipBody.displayName = "TooltipBody";
